import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { brandingConfig } from '../../config/branding';

interface BrandingSettings {
    theme?: {
        primaryColor: string;
        secondaryColor: string;
        backgroundColor: string;
        textColor: string;
        fontFamily: string;
    };
    company?: {
        name: string;
        websiteUrl: string;
        logo?: {
            url: string;
            width: number;
        };
    };
}

interface FooterProps {
    variant?: 'admin' | 'public';
    backgroundColor?: string;
    branding?: BrandingSettings;
}

const Footer: React.FC<FooterProps> = ({ variant = 'admin', backgroundColor, branding }) => {
    const { copyright } = brandingConfig;
    const isPublic = variant === 'public';
    
    // Use branding settings if available, fallback to static config
    const footerContent = {
        year: copyright.year,
        product: copyright.product,
        tagline: copyright.tagline,
        company: copyright.company,
        websiteUrl: copyright.websiteUrl,
        website:  copyright.website
    };

    const textColor = branding?.theme?.textColor || 'text.secondary';
    
    return (
        <Box
            component="footer"
            sx={{
                py: isPublic ? 1 : 2,
                px: isPublic ? 2 : 3,
                mt: 'auto',
                ...(variant === 'admin' && {
                    borderTop: '1px solid',
                    borderColor: 'divider',
                }),
                ...(isPublic && {
                    //backgroundColor: backgroundColor || branding?.theme?.backgroundColor || 'transparent'
                    marginTop: '20px',
                    marginBottom: '0'
                }),
                textAlign: 'center'
            }}
        >
            <Typography
                variant="body2"
                color={textColor}
                sx={{
                    fontSize: isPublic ? '0.75rem' : '0.75rem',
                    opacity: isPublic ? 0.9 : 0.9,
                    fontWeight: isPublic ? 300 : 400
                }}
            >
                {footerContent.year} {footerContent.product} - {footerContent.tagline}
            </Typography>
            <Typography
                variant="body2"
                color={textColor}
                sx={{
                    fontSize: isPublic ? '0.75rem' : '0.75rem',
                    opacity: isPublic ? 0.9 : 0.9,
                    mt: 0.5,
                    fontWeight: isPublic ? 300 : 400
                }}
            >
                Developed by {footerContent.company} |{' '}
                <Link
                    href={footerContent.websiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        color: 'inherit',
                        textDecoration: 'none',
                        '&:hover': {
                            textDecoration: isPublic ? 'none' : 'underline',
                            opacity: isPublic ? 1 : 1
                        }
                    }}
                >
                    Visit {footerContent.website}
                </Link>
            </Typography>
        </Box>
    );
};

export default Footer;
